<script>
import ButtonAll from '../../Button/ButtonAll.vue'
import LanguageTopbarMenu from './LanguageTopbarMenu.vue'
import jsonRequestMixins from '../../../../Mixins/jsonRequestMixins'
import { globalVariablesMixin } from '../../../../Mixins/global'
import mixinComponent from '../../../../Mixins/mixinComponent'
import FlagIcon from '../../Icon/FlagIcon.vue'
import SwitchUserTopbarMenu from './SwitchUserTopbarMenu.vue'
import NotificationTopbarMenu from './NotificationTopbarMenu.vue'
import TopbarDropdown from './TopbarDropdown.vue'

export default {
  components: { NotificationTopbarMenu, SwitchUserTopbarMenu, FlagIcon, LanguageTopbarMenu, ButtonAll, TopbarDropdown },
  mixins: [globalVariablesMixin, mixinComponent, jsonRequestMixins],
  emits: ['toggle-side-menu'],
  props: {
    sidebarExpanded: {
      type: Boolean,
      required: false,
      default: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'default', // 'default' or 'client'
    },
  },
  data() {
    return {
      url: null,
      showEye: false,
    }
  },
  methods: {
    redirectToSimulation(ppID = null) {
      let url = '/devis/simulation.php?index=creer'
      if (ppID) {
        url = `/devis/simulation.php?pp=${ppID}&index=creer`
      }
      window.location.href = url
    },
  },

  beforeMount() {
    if (
      user !== null &&
      !user.isAdmin &&
      !user.isBusinessMan &&
      user.platforms.length > 0 &&
      user.platforms[0].documents
    ) {
      let idDoc = user.platforms[0].documents[0].id
      let uniqid = user.platforms[0].documents[0].uniqid
      this.url = config.urlAPI + 'free/documents/' + idDoc + '/download?uniqiddoc=' + uniqid
    }
  },
  computed: {
    availableLocales() {
      return config.conf.locales ?? []
    },

    windowOrigin() {
      return window.location.origin
    },

    isClient() {
      return this.variant === 'client'
    },

    logoClass() {
      return !this.sidebarExpanded ? 'logo--small' : ''
    },

    topbarLeftClass() {
      return this.sidebarExpanded ? 'topbar-left' : 'topbar-left--small'
    },
    canSeeNotification() {
      return conf.notification === true
    },
  },
  watch: {
    '$i18n.locale': {
      handler: function (language) {
        this.patchJSON('users/me/language', { language })
      },
    },
  },
}
</script>
<template>
  <header v-if="isLogged" class="topbar">
    <div :class="topbarLeftClass">
      <a class="logo" :href="windowOrigin">
        <img
          id="image_logo"
          :class="logoClass"
          v-if="conf.theme_dir"
          :src="'/assets/img/' + conf.theme_dir + '.png'"
          :alt="conf.theme_dir"
        />
      </a>
      <span class="topbar-btn sidebar-toggler mobile-menu" @click="$emit('toggle-side-menu')">
        <i>&#9776;</i>
      </span>
    </div>
    <div class="topbar-center" v-if="!isClient">
      <div class="mr-auto">
        <ButtonAll
          v-if="hasRole('ROLE_APP_ADMIN_ENTITY_FULL')"
          margin="no"
          type="validation"
          data-toggle="modal"
          data-target="#modal-search"
          label="button.search"
          icon="search"
          name="openSearchModal"
        />
      </div>

      <div class="d-flex justify-content-center flex-wrap flex-grow-1">
        <template v-for="platform in user.platforms" v-if="user.platforms.length == 1">
          <div
            :key="platform.id"
            v-if="platform.id == config.platformId && user !== null && !user.isReadOnly"
            class="btn-spacer d-flex justify-content-center flex-wrap btn-spacer"
          >
            <button
              type="button"
              class="btn btn-info"
              v-for="pp in platform.platformParams"
              :key="pp.id"
              @click="redirectToSimulation(pp.id)"
              e2e-button="createSimulation"
            >
              <i :class="'fa fa-' + (pp.icon ? pp.icon : 'file')"></i>
              {{ pp.label ? pp.label : pp.name ? pp.name : $t('quotation.home.defaultLabel') }}
            </button>
          </div>
        </template>
        <div v-if="user !== null && user.platforms.length > 1 && !user.isReadOnly">
          <ButtonAll
            margin="no"
            label="quotation.home.defaultLabel"
            href="/devis/simulation.php?index=creer"
            type="action"
            icon="quote"
            e2e-button="createSimulation"
          />
        </div>
      </div>
    </div>

    <div class="topbar-right">
      <ul class="topbar-btns d-flex align-items-center">
        <TopbarDropdown>
          <template #trigger>
            <span
              id="user-menu-mobile"
              class="topbar-btn strong"
              style="color: #48b0f7"
              data-toggle="dropdown"
              e2e-button="toggleUser"
            >
              <i class="ti-user" />
            </span>
            <span id="user-menu-desktop" class="topbar-btn" data-toggle="dropdown" e2e-button="toggleUser">
              {{ $t('login.hello', { firstname: user.firstname }) }}
            </span>
          </template>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" :href="windowOrigin + '/logout.php'"
              ><i class="ti-power-off" e2e-button="logout" />
              {{ $t('login.logout') }}
            </a>
          </div>
        </TopbarDropdown>

        <SwitchUserTopbarMenu v-if="hasRole('ROLE_ALLOWED_TO_SWITCH')" />
        <template v-if="availableLocales.length > 1">
          <TopbarDropdown>
            <template #trigger>
              <span class="topbar-btn" data-toggle="dropdown">
                <FlagIcon :locale="$i18n.locale" />
              </span>
            </template>
            <LanguageTopbarMenu v-model="$i18n.locale" :locales="availableLocales" />
          </TopbarDropdown>
        </template>
        <NotificationTopbarMenu v-if="canSeeNotification" />
        <li v-if="url">
          <span class="topbar-btn fs-30 d-none d-md-block"><img :src="url" height="70" /></span>
        </li>
      </ul>
    </div>
  </header>
</template>
